module.exports = __webpack_public_path__ + "img/myAuthorized-select.04d695d8.svg";